"use strict";

require("core-js/modules/es.object.from-entries.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultThemeVariables = exports.extendVariables = exports.createVariableDefinitions = exports.createVariableReferences = void 0;

var components_utils_1 = require("@conte-ltd/components-utils");

var breakpoints_1 = require("./breakpoints");

var utils_1 = require("./utils");

var variables_1 = require("./variables");

function buildVariable() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.reduce(function (prev, arg) {
    return prev + "-" + (0, components_utils_1.kebabCase)(arg);
  }, '--c');
}

function createVariableReferences(theme) {
  var parentKeys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    parentKeys[_i - 1] = arguments[_i];
  }

  var entries = Object.entries(theme).map(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    if (typeof value === 'object') {
      return [key, createVariableReferences.apply(void 0, __spreadArray(__spreadArray([value], __read(parentKeys), false), [key], false))];
    } else {
      return [key, "var(" + buildVariable.apply(void 0, __spreadArray(__spreadArray([], __read(parentKeys), false), [key], false)) + ")"];
    }
  });
  return Object.fromEntries(entries);
}

exports.createVariableReferences = createVariableReferences;

function createVariableDefinitions(theme) {
  var parentKeys = [];

  for (var _i = 1; _i < arguments.length; _i++) {
    parentKeys[_i - 1] = arguments[_i];
  }

  return Object.entries(theme).flatMap(function (_a) {
    var _b = __read(_a, 2),
        key = _b[0],
        value = _b[1];

    if (typeof value === 'object') {
      return createVariableDefinitions.apply(void 0, __spreadArray(__spreadArray([value], __read(parentKeys), false), [key], false));
    } else {
      return buildVariable.apply(void 0, __spreadArray(__spreadArray([], __read(parentKeys), false), [key], false)) + ": " + value + ";";
    }
  });
}

exports.createVariableDefinitions = createVariableDefinitions;

function extendVariables(theme, baseTheme) {
  return (0, components_utils_1.merge)([baseTheme !== null && baseTheme !== void 0 ? baseTheme : exports.defaultThemeVariables, theme]);
}

exports.extendVariables = extendVariables;
exports.defaultThemeVariables = {
  // color, background-color, border-color
  color: {
    transparent: 'transparent',
    currentcolor: 'currentcolor',
    black: '#000',
    white: '#fff',
    gray: '#808080',
    primary: '#35b1ba',
    secondary: '#edbf30',
    info: '#3b82f6',
    warning: '#f59e0b',
    error: '#ef4444',
    success: '#10b981'
  },
  // margin, padding, gap, top, left, right, bottom
  spacing: __assign(__assign({}, variables_1.spacing), {
    auto: 'auto',
    none: '0',
    half: '50%',
    full: '100%',
    vwFull: '100vw',
    vhFull: '100vh',
    negative: __assign({}, (0, utils_1.negative)(variables_1.spacing))
  }),
  // width, height, max-width, max-height
  size: __assign(__assign({}, variables_1.size), {
    fit: 'fit-content',
    none: '0',
    half: '50%',
    full: '100%',
    vwFull: '100vw',
    vhFull: '100vh',
    container: {
      sm: breakpoints_1.defaultBreakpoints.sm,
      md: breakpoints_1.defaultBreakpoints.md,
      lg: breakpoints_1.defaultBreakpoints.lg,
      xl: breakpoints_1.defaultBreakpoints.xl
    }
  }),
  fontFamily: {
    system: 'system-ui'
  },
  // font-size
  fontSize: {
    '2xs': '1rem',
    xs: '1.2rem',
    sm: '1.4rem',
    md: '1.6rem',
    lg: '1.8rem',
    xl: '2rem',
    '2xl': '2.4rem',
    '3xl': '2.8rem',
    '4xl': '3.2rem',
    '5xl': '3.6rem',
    '6xl': '4rem',
    '7xl': '4.6rem',
    '8xl': '5.2rem'
  },
  // font-weight
  fontWeight: {
    thin: 100,
    extralight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  // letter-spacing
  letterSpacing: {
    tighter: '0em',
    tight: '0.2em',
    normal: '0.4em',
    wide: '0.6em',
    wider: '0.8em',
    widest: '1em'
  },
  // line-height
  lineHeight: {
    none: 1,
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
    loose: 2
  },
  // border
  border: {
    light: 'solid 1px',
    normal: 'solid 1px',
    medium: 'solid 2px',
    bold: 'solid 4px'
  },
  // border-radius
  radius: {
    none: '0',
    xs: '0.2rem',
    sm: '0.4rem',
    md: '0.6rem',
    lg: '0.8rem',
    xl: '1rem',
    '2xl': '1.6rem',
    '3xl': '2rem',
    full: '9999px'
  },
  // z-index
  zIndex: {
    hide: -1,
    sticky: 100,
    overlay: 1000,
    notice: 2000
  },
  // box-shadow
  shadow: {
    xs: '0 0 0 1px rgba(0, 0, 0, 0.05)',
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
  },
  // opacity
  opacity: {
    '0': 0,
    '10': 0.1,
    '20': 0.2,
    '30': 0.3,
    '40': 0.4,
    '50': 0.5,
    '60': 0.6,
    '70': 0.7,
    '80': 0.8,
    '90': 0.9,
    '100': 1
  },
  // flex-grow, flex-shrink
  flex: {
    none: 0,
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 5,
    '6': 6,
    '7': 7,
    '8': 8,
    '9': 9,
    '10': 10,
    '11': 11,
    '12': 12
  },
  // order
  order: {
    minus: {
      '1': -1,
      '2': -2,
      '3': -3,
      '4': -4,
      '5': -5,
      '6': -6,
      '7': -7,
      '8': -8,
      '9': -9,
      '10': -10
    },
    '0': 0,
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 5,
    '6': 6,
    '7': 7,
    '8': 8,
    '9': 9,
    '10': 10
  },
  // grid-template-columns, grid-template-rows
  gridTemplate: {
    none: 'none',
    '1': 'repeat(1, minmax(0, 1fr))',
    '2': 'repeat(2, minmax(0, 1fr))',
    '3': 'repeat(3, minmax(0, 1fr))',
    '4': 'repeat(4, minmax(0, 1fr))',
    '5': 'repeat(5, minmax(0, 1fr))',
    '6': 'repeat(6, minmax(0, 1fr))',
    '7': 'repeat(7, minmax(0, 1fr))',
    '8': 'repeat(8, minmax(0, 1fr))',
    '9': 'repeat(9, minmax(0, 1fr))',
    '10': 'repeat(10, minmax(0, 1fr))',
    '11': 'repeat(11, minmax(0, 1fr))',
    '12': 'repeat(12, minmax(0, 1fr))'
  },
  // grid-row, grid-column, grid-row-start, grid-row-end, grid-column-start, grid-column-end
  grid: {
    auto: 'auto',
    '1': 1,
    '2': 2,
    '3': 3,
    '4': 4,
    '5': 5,
    '6': 6,
    '7': 7,
    '8': 8,
    '9': 9,
    '10': 10,
    '11': 11,
    '12': 12,
    '13': 13
  },
  // grid-row, grid-column
  gridSpan: {
    '1': 'span 1 / span 1',
    '2': 'span 2 / span 2',
    '3': 'span 3 / span 3',
    '4': 'span 4 / span 4',
    '5': 'span 5 / span 5',
    '6': 'span 6 / span 6',
    '7': 'span 7 / span 7',
    '8': 'span 8 / span 8',
    '9': 'span 9 / span 9',
    '10': 'span 10 / span 10',
    '11': 'span 11 / span 11',
    '12': 'span 12 / span 12',
    full: ' 1 / -1'
  },
  // transition-property
  transition: {
    none: 'none',
    all: 'all',
    colors: 'background-color, border-color, color, fill, stroke, opacity, box-shadow, transform',
    opacity: 'opacity',
    shadow: 'shadow',
    transform: 'transform, top, left, right, bottom'
  },
  // transition-duration, transition-delay
  transitionTime: {
    '50': '50ms',
    '100': '100ms',
    '150': '150ms',
    '200': '200ms',
    '300': '300ms',
    '500': '500ms',
    '600': '600ms',
    '700': '600ms',
    '800': '600ms',
    '900': '600ms',
    '1000': '1000ms',
    '1500': '1500ms',
    '2000': '2000ms'
  },
  // transition-timing-function
  transitionEasing: {
    easein: 'cubic-bezier(0.4, 0, 1, 1)',
    easeout: 'cubic-bezier(0, 0, 0.2, 1)',
    easeinout: 'cubic-bezier(0.4, 0, 0.2, 1)'
  }
};